import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { SEARCH_INTENT_PROJECTS } from "../useSearchIntentProjects/gql";
import { UPDATE_INTENT_PROJECT } from "./gql";

const useUpdateIntentProject = () => {
  const { onError } = useTypedContext(FlashContext);

  const [updateMutation, { loading, error }] = useMutation(UPDATE_INTENT_PROJECT, {
    refetchQueries: [SEARCH_INTENT_PROJECTS],
  });

  const updateIntentProject = useCallback(
    async (input: { id: string; name?: string; description?: string; space?: string }) => {
      try {
        const result = await updateMutation({
          variables: {
            id: input.id,
            name: input.name || null,
            description: input.description || null,
            space: input.space || null,
          },
        });

        return result.data!.intentProjectUpdate;
      } catch (error) {
        onError(error);
        return undefined;
      }
    },
    [updateMutation, onError]
  );

  return {
    updateIntentProject,
    loading,
    error,
  };
};

export default useUpdateIntentProject;
